import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zServiceVehicleSchemaDom, zServiceVehicleSchemaCreateDom, } from "@/types/serviceVehicle/serviceVehicle.domain";
import { zServiceVehicleSchemaDto, zServiceVehicleSchemaCreateDto, } from "@/types/serviceVehicle/serviceVehicle.dto";
import dayjs from "dayjs";
/**
 * Маппер для ServiceVehicle: DTO <-> Domain (1:1).
 */
export const ServiceVehicleMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zServiceVehicleSchemaDom.parse({
        ...dto,
        lastServiceDate: dayjs(dto.lastServiceDate),
    }),
    domainToDto: (domain) => zServiceVehicleSchemaDto.parse({
        ...domain,
        lastServiceDate: domain.lastServiceDate?.toISOString(),
    }),
    dtoToCreateDto: (domain) => zServiceVehicleSchemaCreateDto.parse({
        ...domain,
        lastServiceDate: domain.lastServiceDate?.toISOString(),
    }),
    dtoToCreateDom: (dto) => zServiceVehicleSchemaCreateDom.parse({
        ...dto,
        lastServiceDate: dayjs(dto.lastServiceDate),
    }),
});
